<template>
<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <span class="title_head">Search Transfer</span> 
        </div> 
        <div class="card-body">
          <b-row>
            <b-col md="2">
              <b-form-group>
                <label for="name">Transfer Id </label></br>
                 <input type="text" v-model="search.transfer_id" autocomplete="off" class="form-control" placeholder="Enter Transfer Id" name="">
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group>
                <label for="name">Product Name </label></br>
                </model-list-select>   
                <input type="text" v-model="search.product_name" autocomplete="off" class="form-control" placeholder="Enter Product Name " name="">
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group>
                <label for="name"> Dispatch Date </label></br>
                 <date-picker v-model="search.dispatch_DT" input-name="date" format="YYYY-MM-DD" editable lang="en" style="width: 0px; min-width: 155px;"></date-picker>
              </b-form-group>
            </b-col>

             <b-col md="2">
              <b-form-group>
                <label for="name">Recived Date</label></br>
                <date-picker v-model="search.receive_DT" editable lang="en" style="width: 0px; min-width: 155px;"></date-picker>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group>
                <label for="name">From Shop</label>
                <model-list-select :list="fromshp" option-value="est_shop_id" option-text="est_shop_name" v-model="search.from_sh" placeholder="From Shop" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group>
                <label for="name">To Shop</label>
                <model-list-select :list="toshp" option-value="est_shop_id" option-text="est_shop_name" v-model="search.to_sh" placeholder="To Shop" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
              </b-form-group>
            </b-col>
            
            <div class="col-md-12">
              <center><button v-if="stcktran_view === true" type="button" style="width: 140px; border-radius: 15px;"  @click.prevent="getTotals()"  class="btn btn-pill btn-primary">
              <i class="fa fa-search"></i>&nbsp;Search</button></center></div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
             <div slot="header">
             <div class="row">
                  <div class="col-sm-10">
                     <i style="color: #20a8d8;"></i> Transfer List
                       <a href="#/Addtransfer" class="btn btn-sm btn-primary label_bttn">
                    <i class="fa  fa-plus"></i> Add Transfer
                  </a>
                 </div>
                  <!-- <div class="col-sm-8"> 
                  </div> -->
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                 &nbsp;&nbsp;
                  <div class="col-sm-1">
                  <button  id = 'MyDownload'
                   type="button"
                    v-if="stcktran_rights === true"
                    class="btn btn-sm btn-primary label_bttn"
                    @click="exportData"
                  >
                    <i class=""></i> Export Data
                    
                  </button></div>

            <!-- <span class="title_head">Transfer List</span>&nbsp;&nbsp;
            <span v-if="stcktran_rights === true">
              <a href="#/Addtransfer" class="btn btn-sm btn-primary label_bttn"><i class="fa  fa-plus"></i> Add Transfer</a>
            </span>
          <span
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
               
                  <button  id = 'MyDownload'
                   type="button"
                    v-if="stcktran_rights === true"
                    class="btn btn-sm btn-primary label_bttn"
                    @click="exportData"
                  >
                    <i class="fa fa-plus"></i> Export Data
                    
                  </button>
              </span> -->
             </div>
             </div>
          </div> 
          <div class="card-body">
            <template>
              <div>
                <vue-good-table
                 :columns="columns"
                 :rows="rows"
                 mode="remote"
                 ref="my-table"
                 @on-page-change="onPageChange"
                 @on-sort-change="onSortChange"
                 @on-column-filter="onColumnFilter"
                 @on-per-page-change="onPerPageChange"
                 :totalRows="totalRecords"
                 :pagination-options="{enabled: true, perPage: 5,}" 
                 styleClass="vgt-table striped bordered table-sm condensed">
                  <template slot="table-row" slot-scope="props">

                    <span v-if="props.column.field == 'check'">
                      <span v-if="props.row.companyproducts!=undefined">   
                        {{props.row.companyproducts.product_name}}
                      </span> 
                      <span v-else>         
                        {{props.row.product_name}}
                      </span>
                    </span>

                    <span v-if="props.column.field == 'product_qty_lb'">
                        {{props.row.product_qty}}
                    </span>

                    <span v-if="props.column.field == 'est_shop_id_from_lb'">
                      <span v-if="props.row.shopestablishments_from!=undefined">   
                        {{props.row.shopestablishments_from.est_shop_name}}
                      </span> 
                      <span v-else>         
                        {{props.row.shp_from}}
                      </span>
                    </span>

                    <span v-if="props.column.field == 'est_shop_id_to_lb'">
                      <span v-if="props.row.shopestablishments_to!=undefined">   
                        {{props.row.shopestablishments_to.est_shop_name}}
                      </span> 
                      <span v-else>         
                        {{props.row.shp_to}}
                      </span>
                    </span>
                    <span v-if="props.column.field == 'action'">

                      <span v-if="stcktran_rights === true">
                        <span v-if="props.row.id==transfer.id_ed">
                            <i class="fa fa-save" style="color:#63c2de;font-size: 20px;  cursor: pointer;" @click.prevent="updateTransfer(props.row)"></i>   
                        </span>
                        <span v-else>
                            <i class="fa fa-edit" style="color:#63c2de;font-size: 20px; cursor: pointer;" @click.prevent="editTransfer(props.row)"></i>
                            <i class="fa fa-trash" style="color:#f86c6b;font-size: 20px; cursor: pointer;" @click.prevent="deleteTransfer(props.row)"></i>
                        </span>
                      </span>
                      <span v-else>
                        <i class="fa fa-edit" style="color:grey !important;"></i>
                        <i class="fa fa-trash" style="color:grey !important;"></i>
                      </span>

                    </span>
                    <span v-else-if="props.column.field == 'dispatch_datetime'">
                      {{newDate(props.row.dispatch_datetime)}}
                    </span>
                    <span v-else-if="props.column.field == 'receive_datetime'">
                      {{newDate(props.row.receive_datetime)}}
                    </span>
                    <span v-else>
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
  import Spinner from '../../spinner.vue'
  import DatePicker from 'vue2-datepicker'
  export default {
    components: {
      'date-picker':  DatePicker,Spinner
    },

    data() {
    return {
      // pg_view:false,
      // pg_rights:false,
      // hide:false,
      shpfrst_time:false,
		  tfrst_time:false,
		  gfrst_time:false,
      loading:false,
      fromshp:[],
      toshp:[],
      transfer:{
        id_ed:'',
        productid_ed:'',
        qty_ed:'',
        toshp:'',
        fromshp:'',
        dispatched:'',
        received:'',
      },
      totalRecords: 0,
      serverParams: {
       columnFilters: {
                   },
        sort: {
          // field: 'purchase_id', 
          // type: 'asc',
              },
        page: 1, 
        perPage: 5
      },
      search:{
        transfer_id : '',
        product_name : '',
        dispatch_DT : '',
        receive_DT : '',
        from_sh : '',
        to_sh : '',
      },
      columns: [
      {
        label: 'Transfer Id',
        field: 'stock_transfer_id',
        width: '5% !important'
      },
      {
        label: 'Product Name',
        field: 'check',
        width: '30% !important'
      },
      {
        label: 'From Shop',
        field: 'est_shop_id_from_lb',
        width: '15% !important'
      },
      {
        label: 'To Shop',
        field: 'est_shop_id_to_lb',
        width: '15% !important'
      },
      {
        label: 'Qty',
        field: 'product_qty_lb',
        width: '5% !important'
      },
      {
        label: 'Dispatch Date',
        field: 'dispatch_datetime',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
        dateOutputFormat: 'Do MMM YYYY',
        tdClass: 'text-left',
        thClass: 'text-left',
        width: '15% !important'
      },
      {
        label: 'Recived Date',
        field: 'receive_datetime',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
        dateOutputFormat: 'Do MMM YYYY',
        tdClass: 'text-left',
        thClass: 'text-left',
        width: '15% !important'
      },
      ],
      rows: [],
    }
    },
    computed:{
      stcktran_view: function(){
        if(this.$store.getters.get_stcktran_view === true){
            this.shopuser('comp');
            this.getTotals('comp');
            this.getShop('comp');
            return true
        }
        else{
          return false
        }
      },
      stcktran_rights: function(){
        return this.$store.getters.get_stcktran_rights
      }
    },
    // created(){
    //   var roles = JSON.parse(localStorage.getItem('roles'))
    //   if(roles[17].page_name == 18){
    //     this.pg_view = roles[17].view
    //     // this.pg_rights = roles[17].rights
    //     if(this.pg_view){
    //       this.shopuser();
    //       this.getTotals();
    //       this.getShop();
    //     }
    //   }
    // },
    methods: {
      newDate(date1)
         {
           var dt1 =  new Date(date1)
           var year=dt1.getFullYear()
           var month=dt1.getMonth()+1;
           var day=dt1.getDate();
           var dt2 = year+'-'+month+'-'+day
           return dt2
          },


    updateParams(newProps) {
          this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
    
    onPageChange(params) { 
           this.updateParams({page: params.currentPage});
           this.getTotals();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.getTotals();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.getTotals();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.getTotals();
    },
      shopuser(val){
        if(val === 'comp'){
          if(this.shpfrst_time === false){
            this.shpfrst_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/shopusers').then(function(response){

        }).catch(function(error){
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
          if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
        })
      },

      getShop(val){
        if(val === 'comp'){
          if(this.gfrst_time === false){
            this.gfrst_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/shopestablishments').then(function (response) {
          _this.fromshp=response.data
          _this.toshp=response.data
        }).catch(function (error) {
          console.log(erro);  
        });
      },

      getTotals(val){
        
        if(val === 'comp'){
          if(this.tfrst_time === false){
            this.tfrst_time = true
          }
          else{
            return
          }
        }
        var _this=this
        var data = [];
        this.rows = [];
        this.loading = true
        var num=/^[0-9]{1}$/
        var filteParam = {};
        filteParam.page = this.serverParams.page;
        filteParam.perPage = this.serverParams.perPage;
        filteParam.sort = this.serverParams.sort;
        var transfer_id = this.search.transfer_id
        var product_name = this.search.product_name
        // var dispatch_DT = this.search.dispatch_DT
        // var receive_DT = this.search.receive_DT
        var from_sh = this.search.from_sh
        var to_sh = this.search.to_sh
        var myDate1 = new Date(this.search.dispatch_DT)
        var myDate2 = new Date(this.search.receive_DT)
        var num=/^[0-9]{1}$/
        var year1=myDate1.getFullYear()
        var month1=myDate1.getMonth()+1;
        var daycon=myDate1.getDate();
        if(num.test(month1)==true){ var month1='0'+month1 }else{ var month1=month1 }
        if(num.test(daycon)==true){ var day1='0'+daycon }else{ var day1=daycon }
   
        var year=myDate2.getFullYear()
        var month=myDate2.getMonth()+1;
        var day=myDate2.getDate();
        if(num.test(month)==true){ var month='0'+month }else{ var month=month  }
        if(num.test(day)==true){ var day='0'+day }else{ var day=day }

        var receive_DT=year+'-'+month+'-'+day
        var dispatch_DT=year1+'-'+month1+'-'+day1
        transfer_id = transfer_id.split(' ').join('_')
        product_name = product_name.split(' ').join('_')
        from_sh = from_sh.split(' ').join('_')
        to_sh = to_sh.split(' ').join('_')

        if(this.search.transfer_id!=''){
          data=data+"&filter[where][stock_transfer_id]="+transfer_id
        }
        if(this.search.product_name!=''){
          data= data+"&filter[where][product_name]=%"+product_name+"%"
        }
        if(this.search.dispatch_DT!=''){
          data= data+"&filter[where][dispatch_datetime]="+dispatch_DT
        }
        if(this.search.receive_DT!=''){
          data=data+"&filter[where][receive_datetime]="+receive_DT
        }
        if(this.search.from_sh!=''){
          data= data+"&filter[where][est_shop_id_from]=%"+from_sh+"%"
        }
        if(this.search.to_sh!=''){
          data= data+"&filter[where][est_shop_id_to]=%"+to_sh+"%"
        }
        
        this.$http.get('/api/stocktransfers/transfer_search?params='+JSON.stringify(filteParam)+data)
        .then(function(response){
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift()
          if(response.data != undefined)
          _this.rows = response.data;
          _this.reset()
          _this.loading = false
        }).catch(function(error){
          console.log(error)
          _this.loading = false
        })
      },

          //Nishith Changes For Excel Report 
  exportData(){
      // alert('data')
     this.loading = true;
     var _this = this;

    
    if(this.rows.length > 0 ) {

    
      this.$http.get('/api/stocktransfers/getStocktransferExport').then(function (response) {


  //  console.log(response)
  
  //  alert('isslke paas')
   var access_token = localStorage.getItem('authUser')
  //  console.log(response.data)
  //  _this.loading = 'false';
        var url1 = _this.baseURL2+'/api/containers/csv/download/'+response.data+'?access_token='+access_token
        // console.log('url  '  + url1)
        // var url1 = '/api/containers/csv/download/1593025721009.csv';
        _this.loading = false;
        _this.$http({
          url: url1,
          method: 'GET',
          responseType: 'blob',
        }).then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.setAttribute('download', response.data);
          link.href = url1;
          document.body.appendChild(link);
          link.click();
           _this.loading =false;
        }).catch(function (er) {
          console.log(er);
          _this.loading = false;
        });
 ///End OF Exce Downlod Method...
  });     
    } else {
       _this.loading = false;
       alert('No Rows Found')
    }  
  },

      editTransfer(transferdetail){
        this.transfer.id_ed = transferdetail.id,
        this.transfer.productid_ed = transferdetail.product_id,
        this.transfer.qty_ed = transferdetail.product_qty,
        this.transfer.fromshp = transferdetail.est_shop_id_from,
        this.transfer.toshp = transferdetail.est_shop_id_to,
        this.transfer.dispatched = transferdetail.dispatch_datetime,
        this.transfer.received = transferdetail.receive_datetime
      },
      updateTransfer(transfer_det){
        var _this=this
        var data={
          product_id:this.transfer.productid_ed,
          product_qty:this.transfer.qty_ed,
          est_shop_id_from:this.transfer.fromshp,
          est_shop_id_to:this.transfer.toshp,
          dispatch_datetime:this.transfer.dispatched,
          receive_datetime:this.transfer.received,
        }
        this.$http.post('/api/stocktransfers/update?where[id]='+transfer_det.id,data).then(function(response){
          _this.getTotals();
          _this.transfer.id_ed='';
        }).catch(function(error){
          console.log(error)
        })
      },
      deleteTransfer(transferid){
        var _this=this
        var id = transferid.id;
        this.$http.delete('/api/stocktransfers/'+id).then(function (response) {
          _this.getTotals();
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      reset(){
        this.search.transfer_id = ''
        this.search.product_name = ''
        this.search.dispatch_DT = ''
        this.search.receive_DT = ''
        this.search.from_sh = ''
        this.search.to_sh = ''
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/transfer/listtransfer.vue